import moment from 'moment-timezone';

const format = 'DD/MM/YYYY hh:mm A';

const timeFormat = 'hh:mm:ss A, DD/MM/YYYY';

/**
 *
 */
export default class DateUtils {
    /**
     * Function returns formatted date
     *
     * @param {*} dt
     * @returns
     */
    static getDate = (dt) => {
        return moment(dt).format(timeFormat);
    };

    /**
     * Time Format
     *
     * @param {*} dt
     * @returns
     */
    static getTime = (dt) => {
        return moment.tz(dt, process.env.REACT_APP_TIMEZONE).utc().format(timeFormat);
    };

    static getDifferent = (start_time, end_time) => {
        let start = moment(start_time);

        let end = moment(end_time);

        let diff = end.diff(start, 'minutes', true);

        return diff.toFixed(2);
    };

    /* *
     * Function returns difference between two dates
     *
     * @param {*} dt1 dt2
     * @returns
     */
    static getDateDifference = (dt1, dt2) => {
        var time_taken = moment.duration(moment(dt2, 'hh:mm').diff(moment(dt1, 'hh:mm')));

        var time = [];
        // time.hours = parseInt(time_taken.asHours());
        time.minutes = parseInt(time_taken.asMinutes());
        // time.seconds = parseInt(time_taken.asSeconds()) % 60;

        return time;
    };
}
/**
 * Converts an ISO date string to DD/MM/YYYY format.
 *
 * @param {string | Date} isoDate - The ISO date string or Date object.
 * @returns {string} Formatted date string in DD/MM/YYYY.
 */
export function formatToDDMMYYYY(isoDate) {
    const date = new Date(isoDate); // parse ISO string
    const day = String(date.getDate()).padStart(2, '0'); // day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}
